export default function(data = {}) {
    this.name = data.name;
    this.active = data.active;
    this.year = data.year;
    this.file = { id: '', type: 'file' };
}
